export const promotionInfo = {
	title: "Información de la promoción",
	description:
		"Defina todos los parámetros necesarios para crear una promoción especializada para sus clientes.",
	channelAndAudience: {
		title: "Canal y público objetivo de la promoción",
		description: "Elija el canal de distribución y quién podrá recibir la promoción.",
		channelTitle: "Elija el tipo de canal",
		channelInfo: "Define en qué canal de venta se distribuirá y aplicará la promoción.",
		channels: {
			cashlessMesas: {
				title: "Cashless/Mesas",
				description: "Promoción aplicada en la venta cashless o mesas",
			},
			ficha: {
				title: "Ficha",
				description: "Promoción aplicada en la venta ficha",
			},
			totemFicha: {
				title: "Tótem Ficha",
				description: "Promoción aplicada en el tótem ficha",
			},
		},
		audienceTitle: "¿Quién podrá recibir esta promoción?",
		audienceInfo:
			"Define quién puede recibir la promoción y si será necesario informar el CPF del cliente en la venta para aplicarla.",
		audience: {
			everybody: "Todos los clientes",
			identifiedCpf: "Cliente identificado con CPF",
		},
		identifiedCpfWarning:
			"Es necesario que los tótems tengan conexión a internet para promociones con identificación de cliente.",
	},
	generalData: {
		title: "Datos generales de la promoción",
		description:
			"Informe el nombre y la descripción de la promoción y los locales a los que estará asignada.",
	},
	promotionName: {
		label: "Nombre de la promoción",
		placeholder: "Ingrese el nombre de la promoción",
	},
	promotionDescription: {
		label: "Descripción de la promoción",
		placeholder: "Ingrese la descripción de la promoción",
	},
	expiration: {
		label: "Expiración",
		info:
			"La promoción será válida hasta la fecha seleccionada. Cuando llegue la fecha de expiración, la promoción quedará inactiva y usted podrá cambiar la fecha de expiración.",
		notExpire: "No expira",
	},
	places: "Locales de la promoción",
	placesAll: "Todos",
	errors: {
		requiredField: "Este campo es obligatorio",
		dateFormat: "Formato de fecha inválido",
		dayDiff: "Necesario al menos un día de diferencia",
		selectPlace: "Seleccione al menos un local",
		maxUses:
			"Valor no puede ser superior a la cantidad de productos definida en el paso anterior",
	},
};
